import { cva } from '@/styled-system/css';

export const datePickerContentRecipe = cva({
  base: {
    display: 'flex',
    borderRadius: 'obj.soft',
    flexDirection: 'column',
    backgroundColor: 'DatePicker.Content.bg',
    boxShadow: 'md',
    position: 'relative',
    overflow: 'hidden',
    paddingBlock: 'default',
    paddingInline: 'default',
  },
  variants: {
    modal: {
      true: {
        blockSize: 'auto',
        animation: 'zoom-in 0.2s ease-out',
      },
      false: {},
    },
  },
});

export const datePickerContentPositionerRecipe = cva({
  variants: {
    modal: {
      true: {
        zIndex: 2,
      },
      false: {
        zIndex: 'datePicker',
      },
    },
  },
});
